import {
  updateNewsById,
  insertNews,
  deleteNewsById,
  updateNewsFileById,
}
  from '../api';

const newsArgs = (
  titlePt,
  titleEs,
  link,
  image,
  date,
) => ({
  titlePt,
  titleEs,
  link,
  image,
  date,
});

const addNews = (
  titlePt,
  titleEs,
  link,
  image,
  date,
) => {
  const formData = new FormData();
  formData.append('titlePt', titlePt);
  formData.append('titleEs', titleEs);
  formData.append('link', link);
  formData.append('image', image);
  formData.append('date', date);

  return insertNews(formData);
};

const deleteNews = (id) => deleteNewsById(id);

const updateNews = (
  id,
  titlePt,
  titleEs,
  link,
  image,
  date,
) => updateNewsById(id, newsArgs(titlePt, titleEs, link, image, date));

const updateNewsFile = (
  id,
  titlePt,
  titleEs,
  link,
  image,
  date,
) => {
  const formData = new FormData();
  formData.append('titlePt', titlePt);
  formData.append('titleEs', titleEs);
  formData.append('link', link);
  formData.append('image', image);
  formData.append('date', date);
  return updateNewsFileById(id, formData);
};

export {
  addNews,
  updateNews,
  updateNewsFile,
  deleteNews,
};
